import React from "react";
import { Snackbar, Alert, AlertColor, Button } from "@mui/material";

interface NotificationProps {
  open: boolean;
  message: string;
  severity: AlertColor;
  onClose: () => void;
  anchorOrigin?: {
    vertical: "top" | "bottom";
    horizontal: "left" | "center" | "right";
  };
  action?: {
    label: string;
    onClick: () => void;
  };
}

const Notification: React.FC<NotificationProps> = ({
  open,
  message,
  severity,
  onClose,
  anchorOrigin = { vertical: "bottom", horizontal: "center" },
  action,
}) => {
  return (
    <Snackbar
      open={open}
      autoHideDuration={action ? 5000 : 3000}
      onClose={onClose}
      anchorOrigin={anchorOrigin}
    >
      <Alert
        onClose={onClose}
        severity={severity}
        sx={{ width: "100%" }}
        variant="filled"
        action={
          action ? (
            <Button
              color="inherit"
              size="small"
              onClick={action.onClick}
              sx={{ textTransform: "none" }}
            >
              {action.label}
            </Button>
          ) : undefined
        }
      >
        {message}
      </Alert>
    </Snackbar>
  );
};

export default Notification;
